
const tableDefault = {
    cellPaddingBlock: 14.5,
}

export const tableLite = {
    ...tableDefault,
    headerBg: 'rgba(248, 248, 248, 1)',
    headerColor: 'rgba(101, 101, 101, 1)',
}

export const tableDark = {
    ...tableDefault,
}